"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgFreeCancellation(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 18
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "free-cancellation_svg__a",
    x1: "50%",
    x2: "50%",
    y1: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#00E04B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#0B95F0"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#free-cancellation_svg__a)",
    d: "M7.23 0c.843.095 2.054.804 3.635 2.129 1.01.774 2.207 1.219 3.591 1.333.22 5.681-2.163 10.028-7.148 13.878-.058.026-.107.026-.146 0C2.177 13.49-.206 9.143.014 3.462c1.318-.109 2.467-.517 3.446-1.225C5.092.845 6.352.1 7.239 0H7.23z",
    transform: "translate(0 .016)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    d: "M4.228 8.667l3.007 2.426 3.878-4.859"
  })));
}

var MemoSvgFreeCancellation = /*#__PURE__*/React.memo(SvgFreeCancellation);
var _default = MemoSvgFreeCancellation;
exports["default"] = _default;